import { Component } from "react";
import ServicioComun from "../../../servicios/Comun";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import { __MaximoCaracteresIdentificacion } from "../../../Utils/Funciones";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import es from "date-fns/locale/es"; // the locale you want
import InputMask from "react-input-mask";
import ParametroConsultaAutorizaciones from "../../../Contenedores/Autorizaciones/ParametroConsultaAutorizaciones";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import ResultadoConsulta from "./ResultadoConsultaAutorizaciones";
import DetalleAutorizacion from "./DetalleAutorizacion";
import TipoPersonaDropdown from "../../Comunes/Dropdowns/TiposPersona/TipoPersonaDropdown";
import PageHeading from "../../Comunes/PageHeading";

registerLocale("es", es);
export class ParametrosConsultaAutorizaciones extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ListaTiposAutorizacion: [],
      ListaUsuarioTramite: [],
      identificacion: "",
      seleccionTipoPersona: "0",
      seleccionTipoAutorizacion: "0",
      seleccionUsuarioTramite: "0",
      MaximoCaracteres: 9,
      fechaDesde: null,
      fechaHasta: null,
      resultadoConsulta: [],
      parametrosCargados: [],
      numeroAutorizacion: "",
      DatosParaDetalle: [],
      //Parametros de ocultar o mostrar información a nivel de resultado y detalle autorización
      mostrarDatatable: false,
      MostrarComponenteResultados: false,
      OcultarParametrosBusqueda: false,
      MostrarDetalleConsulta: false,
    };

    this._onSeleccionTipoPersona = this._onSeleccionTipoPersona.bind(this);
    this._onSeleccionTipoAutorizacion =
      this._onSeleccionTipoAutorizacion.bind(this);
    this._fechaDesdeSeleccionada = this._fechaDesdeSeleccionada.bind(this);
    this._fechaHastaSeleccionada = this._fechaHastaSeleccionada.bind(this);
    this._ConsulteAutorizaciones = this._ConsulteAutorizaciones.bind(this);
    this._onSeleccionUsuarioTramite =
      this._onSeleccionUsuarioTramite.bind(this);
    this._ObtengaIdentificacion = this._ObtengaIdentificacion.bind(this);
    this._ObtengaNumeroAutorizacion =
      this._ObtengaNumeroAutorizacion.bind(this);
    this.limpiarFiltros = this.limpiarFiltros.bind(this);
  }

  async componentDidMount() {
    await this.ObtengaCombobox();
  }

  async ObtengaCombobox() {
    let listaTiposAutorizacion = await ServicioComun.ObtengaTiposAutorizacion();
    let Usuarios =
      await ServicioAutorizaciones.ObtengaUsuariosTramiteAutorizaciones();

    this.setState({
      ListaTiposAutorizacion: listaTiposAutorizacion,
      ListaUsuarioTramite: Usuarios,
    });
  }

  async _onSeleccionTipoPersona(e) {
    let valor = e.target.value;
    let max = await __MaximoCaracteresIdentificacion(valor);

    this.setState({
      MaximoCaracteres: max,
      seleccionTipoPersona: valor,
    });
  }

  async _onSeleccionTipoAutorizacion(e) {
    this.setState({
      seleccionTipoAutorizacion: e.target.value,
    });
  }

  async _onSeleccionUsuarioTramite(e) {
    this.setState({
      seleccionUsuarioTramite: e.target.value,
    });
  }

  async _ObtengaIdentificacion({ target: { value } }) {
    this.setState({
      identificacion: value,
    });
  }
  async _ObtengaNumeroAutorizacion({ target: { value } }) {
    this.setState({
      numeroAutorizacion: value.replace("-", ""),
    });
  }

  async maskIdentificacion(v) {
    let digitos = !v ? "" : v.replace(/[^\d]/g, "");
    if (digitos.length > this.state.MaximoCaracteres) {
      digitos = v.substring(0, this.state.MaximoCaracteres);
      this.setState({ identificacion: digitos });
    }
    return digitos;
  }

  async _fechaDesdeSeleccionada(date) {
    this.setState({
      fechaDesde: date !== null ? date : null,
    });
  }

  async _fechaHastaSeleccionada(date) {
    this.setState({
      fechaHasta: date !== null ? date : null,
    });
  }

  async _VolverAParametrosConsulta(mensajeExitoso) {
    this.setState({
      OcultarParametrosBusqueda: false,
      MostrarDetalleConsulta: false,
      mostrarDatatable: true,
    });

    await this._ConsulteAutorizaciones();

    if (mensajeExitoso) {
      Notificar("success", mensajeExitoso);
    }
  }

  async _CargarDetalles(datos) {
    this.setState({
      OcultarParametrosBusqueda: true,
      MostrarDetalleConsulta: true,
      mostrarDatatable: false,
      DatosParaDetalle: datos,
    });
  }

  cargarParametrosConsulta() {
    let parametro = new ParametroConsultaAutorizaciones();
    let numeroAutorizacion = this.state.numeroAutorizacion;
    parametro.Identificacion = this.state.identificacion;
    parametro.TipoPersona =
      this.state.seleccionTipoPersona === "0"
        ? null
        : this.state.seleccionTipoPersona;
    parametro.FechaTramiteDesde = this.state.fechaDesde;
    parametro.FechaTramiteHasta = this.state.fechaHasta;
    parametro.NumeroAutorizacion =
      numeroAutorizacion === "" ? null : numeroAutorizacion;
    parametro.TipoAutorizacion =
      this.state.seleccionTipoAutorizacion === "0"
        ? null
        : this.state.seleccionTipoAutorizacion;
    parametro.UsuarioTramiteIdentificacion =
      this.state.seleccionUsuarioTramite === "0"
        ? null
        : this.state.seleccionUsuarioTramite;
    return parametro;
  }

  limpiarFiltros = () => {
    this.setState({
      identificacion: "",
      seleccionTipoPersona: "0",
      seleccionTipoAutorizacion: "0",
      seleccionUsuarioTramite: "0",
      fechaDesde: null,
      fechaHasta: null,
      numeroAutorizacion: "",
    });
  };

  async _ConsulteAutorizaciones() {
    let parametros = this.cargarParametrosConsulta();
    var consulta = await ServicioAutorizaciones.ConsultaAutorizaciones(
      parametros
    );
    if (consulta.esValido) {
      this.setState({
        resultadoConsulta: consulta.autorizaciones,
        MostrarComponenteResultados: true,
        parametrosCargados: parametros,
        UnaVez: false,
        MostrarDetalleConsulta: false,
        mostrarDatatable: true,
      });
      CerrarNotificador();
    } else {
      Notificar("error", consulta.errores);
    }
  }

  render() {
    return (
      <div>
        {this.state.OcultarParametrosBusqueda === false ? (
          <div>
            <PageHeading title="Consulta de Autorizaciones" />
            <div className="card shadow mb-4">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">
                          Datos de la Persona
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="form-group row">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="TipoPersonaA"> Tipo Persona</label>
                          </div>
                          <div className="col-md-9">
                            <TipoPersonaDropdown
                              id="TipoPersonaA"
                              className="form-control"
                              value={this.state.seleccionTipoPersona}
                              onChange={(e) => this._onSeleccionTipoPersona(e)}
                              permiteSeleccionarValorDefault="true"
                            />
                          </div>
                        </div>
                        <div className="form-group row ">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="IdentificacionID">
                              {" "}
                              Identificación
                            </label>
                          </div>
                          <div className="col-md-9">
                            <InputMask
                              mask={this.maskIdentificacion(
                                this.state.identificacion
                              )}
                              maskChar=""
                              placeholder="Identificación"
                              value={this.state.identificacion}
                              id="IdentificacionID"
                              className="form-control"
                              onChange={this._ObtengaIdentificacion}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">
                          Fecha del Trámite
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="form-group row">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="FechaTramiteDesde"> Desde</label>
                          </div>
                          <div className="col-md-9">
                            <DatePicker
                              id="FechaTramiteDesde"
                              locale="es"
                              selected={this.state.fechaDesde}
                              onChange={this._fechaDesdeSeleccionada}
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="FechaTramiteHasta">Hasta</label>
                          </div>
                          <div className="col-md-9">
                            <DatePicker
                              id="FechaTramiteHasta"
                              locale="es"
                              selected={this.state.fechaHasta}
                              onChange={this._fechaHastaSeleccionada}
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">
                          Datos de la Autorización
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="form-group row">
                          <div className="col-md-2 col-form-label">
                            <label htmlFor="IdTipoAutorizacion">Tipo</label>
                          </div>
                          <div className="col-md-4">
                            <select
                              id="IdTipoAutorizacion"
                              className="form-control"
                              value={this.state.seleccionTipoAutorizacion}
                              onChange={(e) =>
                                this._onSeleccionTipoAutorizacion(e)
                              }
                            >
                              <option value="0">Todas</option>
                              {this.state.ListaTiposAutorizacion.map((item) => (
                                <option
                                  key={item.descripcion}
                                  value={item.codigo}
                                >
                                  {item.descripcion}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-2 col-form-label">
                            <label htmlFor="NumeroAutorizacion"> Número</label>
                          </div>
                          <div className="col-md-4">
                            <InputMask
                              mask="99999999-9999"
                              maskChar=""
                              placeholder="XXXXXXXX-XXXX"
                              value={this.state.numeroAutorizacion}
                              id="NumeroAutorizacion"
                              className="form-control"
                              onChange={this._ObtengaNumeroAutorizacion}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <div className="col-md-2 col-form-label">
                            <label htmlFor="UsuarioTramite">Usuario</label>
                          </div>
                          <div className="col-md-10">
                            <select
                              id="UsuarioTramite"
                              className="form-control"
                              value={this.state.seleccionUsuarioTramite}
                              onChange={(e) =>
                                this._onSeleccionUsuarioTramite(e)
                              }
                            >
                              <option value="0">Todos</option>
                              {this.state.ListaUsuarioTramite.map((item) =>
                                item != null ? (
                                  <option
                                    key={item.identificacion}
                                    value={item.identificacion}
                                  >
                                    {item?.nombrePersona}
                                  </option>
                                ) : null
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <button
                      onClick={this._ConsulteAutorizaciones}
                      type="button"
                      className="btn btn-primary btn-icon-split"
                    >
                      <span className="icon text-white-50">
                        <i className="fas fa-search"></i>
                      </span>
                      <span className="text">Buscar</span>
                    </button>

                    <button
                      id="btnLimpiarFiltros"
                      onClick={this.limpiarFiltros}
                      type="button"
                      className="btn btn-sm btn-light ml-3"
                    >
                      <i className="fas fa-redo fa-sm mr-1"></i>
                      Limpiar filtros
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.MostrarComponenteResultados ? (
          <ResultadoConsulta
            datos={this.state.resultadoConsulta}
            parametrosCargados={this.state.parametrosCargados}
            mostrarDatatable={this.state.mostrarDatatable}
            _CargarDetalles={this._CargarDetalles.bind(this)}
          />
        ) : null}

        <div>
          {this.state.MostrarDetalleConsulta ? (
            <DetalleAutorizacion
              DatosAutorizacion={this.state.DatosParaDetalle}
              VolverAResultados={this._VolverAParametrosConsulta.bind(this)}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default ParametrosConsultaAutorizaciones;
